import { render, staticRenderFns } from "./TheAutomationCampaignPanel.vue?vue&type=template&id=1d5a16e4&scoped=true"
import script from "./TheAutomationCampaignPanel.vue?vue&type=script&lang=js"
export * from "./TheAutomationCampaignPanel.vue?vue&type=script&lang=js"
import style0 from "./TheAutomationCampaignPanel.vue?vue&type=style&index=0&id=1d5a16e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5a16e4",
  null
  
)

export default component.exports